export const REQUEST_SHIPMENT_DATA = "REQUEST_SHIPMENT_DATA";
export const RECEIVE_SHIPMENT_DATA = "RECEIVE_SHIPMENT_DATA";
export const NO_RESULTS_SHIPMENT_DATA = 'NO_RESULTS_SHIPMENT_DATA';
export const RESET_NO_RESULTS_SHIPMENT_DATA = 'RESET_NO_RESULTS_SHIPMENT_DATA';
export const RECEIVE_NOT_FOUND_SHIPMENT_ID = 'RECEIVE_NOT_FOUND_SHIPMENT_ID';
export const REQUESTED_SHIPMENT_DATA = 'REQUESTED_SHIPMENT_DATA';
export const ERROR_RETRIEVING_SHIPMENT_DATA = 'ERROR_RETRIEVING_SHIPMENT_DATA';

export const requestShipmentData = (payload, option) => ({
  type: REQUEST_SHIPMENT_DATA,
  payload, option
});


export const receiveShipmentData = payload => ({type: RECEIVE_SHIPMENT_DATA, payload: payload});

export const receiveNotFoundShipmentIds = payload => ({type: RECEIVE_NOT_FOUND_SHIPMENT_ID, payload: payload});

export const noResultsShipmentData = payload => ({type: NO_RESULTS_SHIPMENT_DATA, payload: payload});

export const resetNoResultsShipmentData = () => ({type: RESET_NO_RESULTS_SHIPMENT_DATA});

export const setRequestedShipmentDataFlag = ()  => ({type: REQUESTED_SHIPMENT_DATA});

export const errorRetrievingShipmentsData = error => ({type: ERROR_RETRIEVING_SHIPMENT_DATA, payload: error});



// WEBPACK FOOTER //
// ./src/actions/shipmentDataActions.js